import { Fragment, useMemo, useState } from "react";

import Shopping from "../../../components/NDC/AirShopping/Shopping";
import { getNdcOfferSegmentRefKey } from "../../../components/NDC/helpers";
import {
  TRIP_TYPE_MULTI_CITY,
  TRIP_TYPE_ONE_WAY,
  TRIP_TYPE_ROUND_TRIP,
} from "../../../common/constants";
import FlightResultAirArabia from "../../../components/AirArabia/FlightResults/FlightResult.airarabia2";
import FlightResultAmadeus from "../../../components/Amadeus/FlightResult/FlightResult.amadeus";

const FlightGrid = ({
  sortedFlights,
  isLocal,
  isReturn,
  channelType,
  tripType,
  getNDCList,
  renderOneWayFlights,
  renderRoundTripFlights,
  renderMultiCityFlights,
  renderReturnTripFlights,
  queryURl,
  company,
  corporate,
  ndcData,
  setLoading,
  discount,
  originalPath,
  airArabiaData: airArabiaDataFromProps,
}) => {
  const [isAirArabiaReturn, setIsAirArabiaReturn] = useState(false);
  const [airArabiaOneWayData, setAirArabiaOneWayData] = useState(null);
  const [isAmadeusReturn, setIsAmadeusReturn] = useState(false);

  const keys = originalPath?.[0]?.Origin + "/" + originalPath?.[0]?.Destination;
  const returnKeys =
    originalPath?.[1]?.Origin + "/" + originalPath?.[1]?.Destination;

  const returnFlights = sortedFlights.filter(
    (flight) =>
      flight.channel === "AirArabia" && flight.segmentKey === returnKeys
  );
  const oneWayFlights = sortedFlights.filter(
    (flight) => flight.channel === "AirArabia" && flight.segmentKey === keys
  );

  const mixedPrices = oneWayFlights.flatMap((oneWay) =>
    returnFlights?.map((ret) => ({
      oneWayId: oneWay.id,
      returnId: ret.id,
      oneWayPrice: oneWay?.data?.cabinPrices?.[0]?.price,
      returnPrice: ret?.data?.cabinPrices?.[0]?.price,
      totalPrice:
        oneWay?.data?.cabinPrices?.[0]?.price +
        ret?.data?.cabinPrices?.[0]?.price,
      ...oneWay,
      returnFlight: ret,
    }))
  );

  const skipNdcFlightIds = useMemo(() => {
    const skip = new Set();
    const seenKeys = new Set();
    for (const f of sortedFlights || []) {
      if (f.channel !== "NDC") continue;
      const k = getNdcOfferSegmentRefKey(f);
      if (!k) continue;
      if (seenKeys.has(k)) skip.add(f.id);
      else seenKeys.add(k);
    }
    return skip;
  }, [sortedFlights]);

  return (
    <div className="grid grid-cols-1 gap-6 rounded-3xl">
      {sortedFlights?.length < 1 && (
        <div className="flex justify-center items-center h-96">
          <h1 className="text-2xl font-bold">No Flights Found</h1>
        </div>
      )}
      {sortedFlights.map((flight, index) => {
        const isNDC = flight.channel === "NDC";
        const isAirArabia = flight.channel === "AirArabia";
        const isAmadeus = flight.channel === "Amadeus";
        if (isNDC && skipNdcFlightIds.has(flight.id)) {
          return null;
        }
        const ndcList = isNDC && getNDCList(flight);
        let airArabiaData =
          isAirArabia && returnFlights?.length >= 1
            ? mixedPrices?.[index]
            : flight;

        return isAmadeus
          ? flight.data && !isReturn && (
              <FlightResultAmadeus
                flight={flight.data}
                amaClientRef={flight.amaClientRef}
                setLoading={setLoading}
                query={queryURl}
                company={company}
                corporate={corporate}
                discount={discount}
                originalPath={originalPath}
                rateDifference={1}
                setIsAmadeusReturn={setIsAmadeusReturn}
                isAmadeusReturn={isAmadeusReturn}
              />
            )
          : isNDC
          ? ndcList &&
            !isLocal &&
            !isReturn &&
            channelType?.includes("NDC") && (
              <Shopping
                key={`NDC-${flight.id}`}
                flight={ndcList}
                dataSet={ndcData}
                setLoading={setLoading}
                query={queryURl}
                company={company}
                corporate={corporate}
                discount={discount}
                originalPath={originalPath}
              />
            )
          : isAirArabia
          ? airArabiaData && (
              <FlightResultAirArabia
                flight={airArabiaData}
                setLoading={setLoading}
                query={queryURl}
                company={company}
                corporate={corporate}
                discount={discount}
                originalPath={originalPath}
                rateDifference={1}
                setIsAirArabiaReturn={setIsAirArabiaReturn}
                isAirArabiaReturn={isAirArabiaReturn}
                setAirArabiaOneWayData={setAirArabiaOneWayData}
                isRoundTrip={returnFlights?.length >= 1}
              />
            )
          : channelType?.includes("GDS") && (
              <Fragment key={flight.id}>
                {tripType === TRIP_TYPE_ONE_WAY && renderOneWayFlights(flight)}
                {tripType === TRIP_TYPE_ROUND_TRIP &&
                  !isReturn &&
                  renderRoundTripFlights(flight)}
              </Fragment>
            );
      })}

      {channelType?.includes("GDS") && (
        <Fragment>
          {tripType === TRIP_TYPE_MULTI_CITY && renderMultiCityFlights()}
          {tripType === TRIP_TYPE_ROUND_TRIP &&
            isReturn &&
            renderReturnTripFlights()}
        </Fragment>
      )}
    </div>
  );
};

export default FlightGrid;
